// extracted by mini-css-extract-plugin
export default {"pageContainer":"eslintDemo_pageContainer__hlLGB"};